import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getLanguages(): Promise<any> {
  return await axiosInstance.get('/languages', getDefaultRequestConfig());
}
